<template>
  <div class="unit-selector">
    <button
      :class="{ active: selected === 'metric' }"
      @click="select('metric')"
      type="button"
    >
      CM / KG
    </button>
    <button
      :class="{ active: selected === 'imperial' }"
      @click="select('imperial')"
      type="button"
    >
      IN / LB
    </button>
  </div>
</template>

<script>
export default {
  name: 'UnitSelector',
  props: {
    modelValue: String // para v-model
  },
  data() {
    return {
      selected: this.modelValue || 'metric'
    };
  },
  watch: {
    modelValue(val) {
      this.selected = val;
    }
  },
  methods: {
    select(unit) {
      this.selected = unit;
      this.$emit('update:modelValue', unit);
    }
  }
};
</script>

<style scoped>
.unit-selector {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin: 1rem 0;
}

.unit-selector button {
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 20px;
  background-color: white;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
}

.unit-selector button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}
</style>
